import Row, { RowBetween } from "components/Layout/Row"
import styled from "styled-components"
import { Flex, Card, Image } from "vvs-uikit"

export const FixedHeightRow = styled(RowBetween)`
  height: 24px;
`
export const LinkButton = styled.button`
  color: ${({ theme }) => theme.colors.failure};
  background: transparent;
  border: none;
  font-size: 16px;
  cursor: pointer;
`
export const TagWrapper = styled(Flex)`
font-weight: 600;
font-size: 16px;
width: fit-content;
border-radius: 18px;
padding: 10px 18px;
`
export const StyledCard = styled(Card)<{ isFinished?: boolean }>`
  max-width: 330px;
  margin: 0 8px 24px;
  display: flex;
  flex-direction: column;
  align-self: baseline;
  position: relative;
  color: ${({ isFinished, theme }) => theme.colors[isFinished ? 'textDisabled' : 'text']};

  ${({ theme }) => theme.mediaQueries.sm} {
    margin: 0 12px 46px;
  }

  ${({ theme }) => theme.mediaQueries.lg} {
    max-width: 380px;
  }
`
export const InlineImage = styled(Image)`
  display: inline-block;
  vertical-align: bottom;
  top: 2px;
`
export const FixedHeightRowEnd = styled(Row)`
  justify-content: flex-end;
  height: 24px;
  padding: 2px;
`